(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["chain-length"] && !Shopify.designMode) return;
  try {
    function updateActiveBlock() {
        const checkedInput = document.querySelector('.product-chain--length .chain--type input:checked');
        const blocks = document.querySelectorAll('.product-chain--length .chain--length .block--type');

        // Remove active from all blocks first
        blocks.forEach(block => block.classList.remove('active'));

        if (!checkedInput) return;

        const selectedValue = checkedInput.value;

        // Add active to the block that matches the selected value
        blocks.forEach(block => {
            if (block.dataset.length === selectedValue) {
                block.classList.add('active');
            }
            if (selectedValue === 'No chain') {
                document.querySelector('.product-chain--length .chain--length .label')?.classList.add('hidden');
                document.querySelectorAll('.chain--length input[type="radio"]').forEach(radio => {
                    radio.checked = false;
                });
            } else if (selectedValue === 'Link chain') {
                document.querySelector('.product-chain--length .chain--length .label')?.classList.remove('hidden');
                document.querySelector('.product-chain--length .chain--length .block--type[data-length="Link chain"] input[value="22”"]')?.click();
            } else {
                document.querySelector('.product-chain--length .chain--length .label')?.classList.remove('hidden');
                document.querySelector('.product-chain--length .chain--length .block--type[data-length="Snake chain"] input[value="16”"]')?.click();
            }
        });

        // document.querySelector('.chain--type-metafield input').value = selectedValue;
    }

    function updateChianLength() {
        const checkedChainLengthInput = document.querySelector('.product-chain--length .chain--length input:checked');
        const selectedChainLengthValue = checkedChainLengthInput.value;
        // document.querySelector('.chain--length-metafield input').value = selectedChainLengthValue;
    }

    // Run on page load
    updateActiveBlock();

    // Run when user changes selection
    document.querySelectorAll('.product-chain--length .chain--type input').forEach(input => {
        input.addEventListener('change', updateActiveBlock);
        // Add event listeners for both Chain Type and Chain Length
        input.addEventListener('change', updateVariantSelection);
    });

    document.querySelectorAll('.product-chain--length .chain--length input').forEach(input => {
        input.addEventListener('change', updateChianLength);
        // Add event listeners for both Chain Type and Chain Length
        input.addEventListener('change', updateVariantSelection);
    });

    function updateVariantSelection() {
        const chainType = document.querySelector('.product-chain--length .chain--type input:checked');
        const chainLength = document.querySelector('.product-chain--length .chain--length input:checked');

        let combinedValue = '';

        if (chainType && chainLength) {
            // Both selected → combine both values
            combinedValue = `${chainType.value} - ${chainLength.value}`.trim();
        } else if (chainType && !chainLength) {
            // Only chain type selected
            combinedValue = chainType.value.trim();
        } else if (!chainType && chainLength) {
            // Only chain length selected
            combinedValue = chainLength.value.trim();
        } else {
            console.warn('No chain type or length selected yet');
            return;
        }

        console.log('Variant search value:', combinedValue);

        // Find the matching Shopify variant input
        const variantInput = document.querySelector(`.variant-picker__form .variant-option.chain-type input[value="${combinedValue}"]`);

        if (variantInput) {
            variantInput.click();
            console.log('Variant selected:', combinedValue);
        } else {
            console.warn('No matching variant found for', combinedValue);
        }
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["new-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
        const tabLinks = document.querySelectorAll('.product-tabs .tabs .tab-link');
        const tabContents = document.querySelectorAll('.product-tabs .tab-content[data-tab]');

        tabLinks.forEach(function (link) {
            link.addEventListener('click', function () {
            const tabText = this.querySelector('span')?.textContent.trim();

            tabLinks.forEach(function (l) {
                l.classList.remove('active');
            });

            this.classList.add('active');

            tabContents.forEach(function (content) {
                content.classList.remove('active');
            });

            tabContents.forEach(function (content) {
                if (content.getAttribute('data-tab').trim() === tabText) {
                content.classList.add('active');
                }
            });
            });
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["new_menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.collections_menu .menu__item').forEach(item => {
        item.addEventListener('click', function () {
            const collection = this.getAttribute('data-collection');

            // Handle .menu__item active class
            document.querySelectorAll('.collections_menu .menu__item').forEach(el => {
            el.classList.remove('active');
            });
            this.classList.add('active');

            // Handle .ui-test-product-list active class
            document.querySelectorAll('.ui-test-product-list .section').forEach(list => {
                if (list.getAttribute('data-collection') === collection) {
                    list.classList.add('active');
                } else {
                    list.classList.remove('active');
                }
            });

            // Handle special case for "FOR HOME"
            if (collection === 'FOR HOME') {
            }
        });
    });
  } catch(e) { console.error(e); }
})();

})();
